import React, { useEffect, useContext, useRef } from 'react';
import { ButtonBack, ButtonNext, DotGroup, Slide, Slider } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { CarouselContext } from 'pure-react-carousel';

// Types
import { AiSuggestionWorkspaceItem } from 'Shared/types/AiSuggestionWorkspaceItem.type';

// Hooks
import useElementDimensions from 'Wpds/hooks/useElementDimensions';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import AgendaAiItem from './AgendaAiItem';

// Styles
import './AgendaAiCarouselSlider.scss';

type Props = {
  aiSuggestions: AiSuggestionWorkspaceItem[];
  setSlideCount: Function;
  setCurrentSlide: any;
  handleAcceptAiSuggestion: Function;
  handleRejectAiSuggestion: Function;
};

const AgendaAiCarouselSlider = ({
  aiSuggestions,
  setSlideCount,
  setCurrentSlide,
  handleAcceptAiSuggestion,
  handleRejectAiSuggestion,
}: Props) => {
  const ref = useRef(null);
  const { width: elementWidth } = useElementDimensions({ elementRef: ref });

  const carouselContext = useContext(CarouselContext);

  useEffect(() => {
    const updateCarouselSlide = (slideToBeVisible: number) => {
      const { currentSlide, totalSlides, visibleSlides } = carouselContext.state;

      setSlideCount(slideToBeVisible);

      //this is a fix to reset currentSlide when screen resizes
      if (
        (currentSlide >= totalSlides - visibleSlides && totalSlides - visibleSlides > 0) ||
        (currentSlide >= totalSlides - slideToBeVisible && totalSlides - slideToBeVisible > 0)
      ) {
        setCurrentSlide(totalSlides - slideToBeVisible);
      }
    };

    if (elementWidth < 832) {
      updateCarouselSlide(1);
    } else if (elementWidth < 1088) {
      updateCarouselSlide(2);
    }
    //>= 1088
    else {
      updateCarouselSlide(3);
    }
  }, [elementWidth, setSlideCount, setCurrentSlide, carouselContext]);

  const baseClassName = 'AgendaAiCarouselSlider';

  return (
    <div className={baseClassName} ref={ref}>
      <div className={`${baseClassName}__slider`}>
        <ButtonBack className="WpButton WpButton--sm WpButton--variant-tertiary WpButton--color-primary WpButton--icon-only">
          <WpIcon name="chevron-left" />
        </ButtonBack>
        <Slider className={`${baseClassName}__slider__carousel`}>
          {aiSuggestions.map((slide, index) => (
            <Slide key={`slid_${slide.slug}`} index={index} className={`${baseClassName}__slide`}>
              <AgendaAiItem
                aiSuggestion={slide}
                handleAcceptAiSuggestion={handleAcceptAiSuggestion}
                handleRejectAiSuggestion={handleRejectAiSuggestion}
              />
            </Slide>
          ))}
        </Slider>
        <ButtonNext className="WpButton WpButton--sm WpButton--variant-tertiary WpButton--color-primary WpButton--icon-only">
          <WpIcon name="chevron-right" />
        </ButtonNext>
      </div>
      <div className={`${baseClassName}__controls`}>
        <DotGroup className="dot-group" />
      </div>
    </div>
  );
};

export default AgendaAiCarouselSlider;
